type GradeOverride = {
  assignmentId: string
  userId: string
  roomId: string
  overrideTotalScore: number
}

export type GradeOverrideMap = ReadonlyMap<string, number>

function gradeOverrideKey(
  assignmentId: string,
  userId: string,
  roomId: string
) {
  return JSON.stringify([assignmentId, userId, roomId])
}

export function createGradeOverrideMap(
  overrides: readonly GradeOverride[]
): GradeOverrideMap {
  return new Map(
    overrides.map((override) => [
      gradeOverrideKey(override.assignmentId, override.userId, override.roomId),
      override.overrideTotalScore,
    ])
  )
}

export function getGradeOverride(
  overrides: GradeOverrideMap,
  assignmentId: string,
  userId: string,
  roomId: string
) {
  return overrides.get(gradeOverrideKey(assignmentId, userId, roomId))
}
